import { Component, Input, OnDestroy } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaldoVendedorService } from '../../services/saldo-vendedor.service';
import { SaldoMotoristaService } from '../../services/saldo-motorista.service';

export type WithdrawalClaim = 'Caller' | 'Driver';

@Component({
  selector: 'app-withdrawal-modal',
  templateUrl: './withdrawal-modal.component.html',
  styleUrls: ['./withdrawal-modal.component.scss'],
  standalone: false,
})
export class WithdrawalModalComponent implements OnDestroy {
  @Input() availableBalance: number = 0;
  @Input() claim: WithdrawalClaim = 'Caller';

  valor: number = 0;
  metodoRecebimento: 'Zelle' | 'ContaBancaria' | 'ContaInternacional' = 'Zelle';
  submitting = false;

  private destroy$ = new Subject<void>();

  constructor(
    private modalCtrl: ModalController,
    private toastCtrl: ToastController,
    private saldoVendedor: SaldoVendedorService,
    private saldoMotorista: SaldoMotoristaService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  isValid() {
    return this.valor > 0 && this.valor <= this.availableBalance;
  }

  async submit() {
    if (!this.isValid()) {
      const toast = await this.toastCtrl.create({
        message: this.valor <= 0 ? 'Enter a valid amount.' : 'Amount exceeds available balance.',
        duration: 2000,
        position: 'bottom',
      });
      await toast.present();
      return;
    }
    this.submitting = true;
    const obs = this.claim === 'Caller'
      ? this.saldoVendedor.requestWithdrawal(this.valor, this.metodoRecebimento)
      : this.saldoMotorista.requestWithdrawal(this.valor, this.metodoRecebimento);
    // takeUntil(destroy$) auto-unsubscribes if the modal is dismissed before the
    // request completes — no leaked subscription, no late-arrival toast on a
    // destroyed component.
    obs.pipe(takeUntil(this.destroy$)).subscribe({
      next: async () => {
        this.submitting = false;
        const toast = await this.toastCtrl.create({
          message: 'Withdrawal request submitted.',
          duration: 2500,
          position: 'bottom',
        });
        await toast.present();
        this.modalCtrl.dismiss({ submitted: true });
      },
      error: async (err) => {
        this.submitting = false;
        const msg = err?.error?.errors?.[0] ?? 'Failed to submit withdrawal request.';
        const toast = await this.toastCtrl.create({ message: msg, duration: 3000, position: 'bottom' });
        await toast.present();
      },
    });
  }
}
